<template>
    <div>
        <input type="hidden" name="id" :value="invoiceItem.id" />
        <router-link
            v-if="
                invoiceItem.item.type == LAB_TYPE &&
                isNewLabProfile &&
                invoiceItem.record_id
            "
            :to="{
                name: 'lab',
                params: {
                    id: invoiceItem.record_id,
                    patientName: invoiceItem.patient.name,
                    patientId: invoiceItem.patient.encoded_id
                }
            }"
        >
            {{ name }}
        </router-link>
        <a
            v-else-if="
                invoiceItem.item.type == LAB_TYPE &&
                invoiceItem.soap &&
                invoiceItem.soap.id &&
                !isNewLabProfile
            "
            :href="getSoapLabLink()"
            v-html="name"
        ></a>
        <a
            v-else-if="
                invoiceItem.item.type == LAB_TYPE &&
                this.invoiceItem.record != null &&
                !isNewLabProfile
            "
            :href="getPatientLabLink()"
            v-html="name"
        ></a>
        <b
            v-else-if="
                invoiceItem.record &&
                invoiceItem.business_id == _setting.business_id &&
                _hasAccess('patient.record.update')
            "
            class="text-primary"
            @click="editRecord"
            :class="disabled ? 'disabled cursor-not-allowed' : 'cursor-pointer'"
        >
            {{ name }}
        </b>

        <b
            v-else-if="invoiceItem.record"
            class="text-primary cursor-pointer"
            @click="viewRecord"
        >
            {{ name }}
        </b>
        <span v-else>
            {{ name }}
        </span>
    </div>
</template>
<script>
/**
 * @see apps/application/models/orm/TblRecord.php Line:114 getUrl()
 */

import RecordService from "@/services/records";
import { merge } from "lodash";
export default {
    props: {
        invoiceItem: {
            type: Object,
            required: true
        },
        name: {
            type: String
        },
        isNewLabProfile: {
            type: Boolean,
            required: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            LAB_TYPE: 7
        };
    },
    methods: {
        getPatientLabLink() {
            return (
                process.env.CI_APPS +
                "patient/lab/view/" +
                this.invoiceItem.patient.id +
                "/" +
                this.invoiceItem.record_id
            );
        },
        getSoapLabLink() {
            return (
                process.env.CI_APPS +
                "soap/lab/view/" +
                this.invoiceItem.soap.id +
                "/" +
                this.invoiceItem.record_id
            );
        },
        editRecord() {
            if (this.disabled) {
                return;
            }

            let record = this.invoiceItem.record;
            let date = this._fromDateCarbon(record.date).toSeconds();
            if (record.invoice_item && record.invoice_item.date) {
                if (
                    this._fromDateCarbon(record.invoice_item.date) <
                    this._fromDateCarbon(record.date)
                ) {
                    date = this._fromDateCarbon(
                        record.invoice_item.date
                    ).toSeconds();
                }
            }

            // if not patient in record object, use patient from invoiceItem which both should use same patient
            record.patient = record.patient
                ? record.patient
                : this.invoiceItem.patient;

            this.$store.dispatch("checkBillingLock", {
                date,
                onProceed: () => {
                    RecordService.editRecordDetails(record.id).then(
                        response => {
                            if (response) {
                                this.$emit(
                                    "edit",
                                    merge({}, record, {
                                        clientID:
                                            this.invoiceItem.patient &&
                                            this.invoiceItem.patient
                                                .primary_owner.length > 0
                                                ? this.invoiceItem.patient
                                                      .primary_owner[0].id
                                                : null,
                                        action: "edit",
                                        module: this.MODULE.PATIENT,
                                        record_resources: response
                                    })
                                );
                            }
                        }
                    );
                },
                onError: message => this._message(message, "danger")
            });
        },
        viewRecord() {
            const record = this.invoiceItem.record;
            RecordService.showRecordDetails(record.id, record.business_id).then(
                response => {
                    if (response) {
                        this.$emit("view", {
                            ...record,
                            record_resources: response
                        });
                    }
                }
            );
        }
    }
};
</script>
